import { useState } from 'react';
import UtilityBar from '../components/layout/UtilityBar';
import Nav from '../components/layout/Navbar';
import Footer from '../components/layout/Footer';
import LincolnAvatar from '../components/ui/LincolnAvatar';
import ImageSlot from '../components/ui/ImageSlot';

/**
 * Course detail page (AI Literacy 101 as the reference). Currently
 * static — the same component renders for any /courses/:slug.
 */
export default function CourseDetail() {
  return (
    <div style={{ background: 'var(--bg)' }}>
      <UtilityBar />
      <Nav variant="light" />

      {/* Hero */}
      <section className="relative overflow-hidden" style={{ background: 'linear-gradient(135deg, var(--navy) 0%, var(--navy-3) 100%)', padding: '60px 0' }}>
        <div className="lc-container on-navy relative" style={{ zIndex: 1 }}>
          <div className="flex items-center gap-2 mb-6" style={{ fontSize: 13, color: 'rgba(255,255,255,0.7)' }}>
            <a href="#" style={{ color: 'rgba(255,255,255,0.7)' }}>Courses</a> ›
            <a href="#" style={{ color: 'rgba(255,255,255,0.7)' }}>AI &amp; Tech</a> ›
            <span className="text-white">AI Literacy 101</span>
          </div>

          <div className="grid items-center" style={{ gridTemplateColumns: '1.5fr 1fr', gap: 60 }}>
            <div>
              <div className="flex gap-2 mb-4">
                <span className="font-bold tracking-wider" style={{ fontSize: 11, padding: '5px 10px', borderRadius: 999, background: 'var(--yellow)', color: 'var(--navy)' }}>★ FEATURED</span>
                <span className="font-semibold text-white" style={{ fontSize: 11, padding: '5px 10px', borderRadius: 999, background: 'rgba(255,255,255,0.1)' }}>BEGINNER</span>
                <span className="font-semibold" style={{ fontSize: 11, padding: '5px 10px', borderRadius: 999, background: 'rgba(34,181,114,0.18)', color: '#7be3b0' }}>WEF PARTNER</span>
              </div>
              <h1 className="text-white" style={{ fontSize: 60, letterSpacing: '-0.02em' }}>AI Literacy 101</h1>
              <p className="mt-4 leading-relaxed" style={{ fontSize: 18, color: 'rgba(255,255,255,0.78)', maxWidth: 580 }}>
                The world&apos;s most-taken AI course. 24 voice-first lessons covering the foundations of artificial intelligence — co-designed with the World Economic Forum.
              </p>

              <div className="mt-5 flex items-center flex-wrap gap-3">
                <div className="flex items-center gap-2">
                  <div className="flex">
                    {[0, 1, 2, 3].map((i) => (
                      <span key={i} className="rounded-full border-2"
                        style={{
                          width: 28, height: 28, borderColor: 'var(--navy)',
                          background: ['#f0b80c', '#22b572', '#2b6cd9', '#c97864'][i],
                          marginLeft: i === 0 ? 0 : -8,
                        }} />
                    ))}
                  </div>
                  <span className="text-white" style={{ fontSize: 14 }}>24,000+ learners</span>
                </div>
                <div style={{ width: 1, height: 16, background: 'rgba(255,255,255,0.2)' }} />
                <div className="flex items-center gap-1.5">
                  <div style={{ color: 'var(--yellow)' }}>★★★★★</div>
                  <span className="text-white font-semibold" style={{ fontSize: 14 }}>4.92</span>
                  <span style={{ fontSize: 13, color: 'rgba(255,255,255,0.6)' }}>(8,124 reviews)</span>
                </div>
              </div>

              <div className="grid mt-7" style={{ gridTemplateColumns: 'repeat(4, auto)', gap: 32 }}>
                {[
                  ['Duration', '6 weeks · ~30 min/lesson'],
                  ['Format',   'Voice-first · self-paced'],
                  ['Languages', 'EN, FI, SV, MT + 6 more'],
                  ['Includes', 'Certificate · QR badge'],
                ].map(([k, v]) => (
                  <div key={k}>
                    <div className="font-bold tracking-widest mb-1" style={{ fontSize: 11, color: 'var(--yellow-2)' }}>{k.toUpperCase()}</div>
                    <div className="text-white font-medium" style={{ fontSize: 13 }}>{v}</div>
                  </div>
                ))}
              </div>
            </div>

            <div className="bg-white" style={{ borderRadius: 20, padding: 28, boxShadow: 'var(--shadow-lg)' }}>
              <div className="relative overflow-hidden mb-5" style={{ height: 180, borderRadius: 14, background: 'var(--yellow)' }}>
                <ImageSlot id="course-hero" style={{ position: 'absolute', inset: 0 }} shape="rect" src="https://images.unsplash.com/photo-1677442136019-21780ecad995?w=900&auto=format&fit=crop&q=80" placeholder="Course cover" />
                <div className="absolute inset-0 flex items-center justify-center pointer-events-none" style={{ fontSize: 64 }}>🤖</div>
                <button type="button" className="absolute inset-0 m-auto inline-flex items-center justify-center rounded-full text-white"
                  style={{ width: 56, height: 56, background: 'rgba(11,31,56,0.85)' }}>
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="#fff"><polygon points="6,4 20,12 6,20" /></svg>
                </button>
              </div>
              <div className="flex items-baseline gap-2.5 mb-3.5">
                <span className="font-bold font-serif" style={{ fontSize: 32, color: 'var(--green-2)' }}>Free</span>
                <span className="line-through" style={{ fontSize: 13, color: 'var(--muted)' }}>$199</span>
                <span className="ml-auto font-bold" style={{ fontSize: 11, padding: '3px 8px', borderRadius: 999, background: 'rgba(34,181,114,0.12)', color: 'var(--green-2)' }}>WEF SCHOLARSHIP</span>
              </div>
              <button type="button" className="lc-btn primary lg w-full" style={{ marginBottom: 10 }}>Enroll &amp; start talking</button>
              <button type="button" className="lc-btn ghost w-full">Preview lesson 1</button>
              <div className="mt-4 pt-4" style={{ borderTop: '1px solid var(--line)' }}>
                {[
                  ['⏱', '6 weeks of content (you can go faster)'],
                  ['🎙', 'Voice tutor in 10 languages'],
                  ['📝', '84 auto-generated quiz questions'],
                  ['🏅', 'QR-verifiable certificate'],
                  ['📱', 'Watch on phone, tablet, web'],
                ].map(([icon, text]) => (
                  <div key={text} className="flex items-center gap-2.5" style={{ padding: '6px 0', fontSize: 13, color: 'var(--ink-2)' }}>
                    <span>{icon}</span>{text}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="lc-section">
        <div className="lc-container">
          <div className="grid items-start" style={{ gridTemplateColumns: '1.6fr 1fr', gap: 60 }}>
            <div>
              <div className="flex" style={{ borderBottom: '1px solid var(--line)', marginBottom: 32 }}>
                {['Curriculum', 'About', 'Reviews', 'Instructor', 'FAQ'].map((t, i) => (
                  <button key={t} type="button" className="font-semibold"
                    style={{
                      padding: '12px 20px',
                      fontSize: 14,
                      color: i === 0 ? 'var(--ink)' : 'var(--muted)',
                      borderBottom: i === 0 ? '2px solid var(--yellow)' : '2px solid transparent',
                      marginBottom: -1,
                    }}>{t}</button>
                ))}
              </div>

              <h2 className="mb-2" style={{ fontSize: 32 }}>What you&apos;ll learn</h2>
              <p className="mb-6" style={{ color: 'var(--muted)', fontSize: 15 }}>
                24 lessons, organized into 6 modules. Lincoln teaches each one through voice — you respond by speaking back.
              </p>

              {[
                { n: '01', title: 'What is AI, really?', lessons: 4, time: '2h', open: true,
                  list: [
                    { name: 'From rules to learning',         time: '28 min' },
                    { name: 'How AI learns from examples',     time: '32 min' },
                    { name: "What 'training' actually means", time: '26 min' },
                    { name: 'Quiz · Module 1',                 time: '15 min', quiz: true },
                  ] },
                { n: '02', title: 'Neural networks, demystified',   lessons: 4, time: '2.5h' },
                { n: '03', title: 'Language models & voice AI',     lessons: 4, time: '2h' },
                { n: '04', title: 'AI bias, ethics & trust',        lessons: 4, time: '2h' },
                { n: '05', title: 'AI in your daily life',          lessons: 4, time: '1.5h' },
                { n: '06', title: 'Build something with AI',        lessons: 4, time: '3h' },
              ].map((m) => (
                <ModuleAccordion key={m.n} {...m} />
              ))}
            </div>

            <aside>
              <div className="mb-5" style={{ background: 'var(--bg-cream)', borderRadius: 16, padding: 22 }}>
                <div className="font-bold tracking-widest mb-3" style={{ fontSize: 11, color: 'var(--muted)' }}>YOUR INSTRUCTOR</div>
                <div className="flex items-center gap-3.5">
                  <LincolnAvatar size={70} />
                  <div>
                    <div className="font-bold font-serif" style={{ fontSize: 18 }}>Lincoln</div>
                    <div style={{ fontSize: 12, color: 'var(--muted)' }}>Lincoln School · AI Tutor</div>
                    <div className="font-semibold mt-0.5" style={{ fontSize: 11, color: 'var(--green-2)' }}>Available 24/7 · 3 languages</div>
                  </div>
                </div>
                <p className="mt-3.5 leading-relaxed" style={{ fontSize: 13, color: 'var(--ink-2)' }}>
                  Lincoln is a voice-native AI tutor. He&apos;s been teaching for 18 months and has had 47M conversations.
                </p>
              </div>

              <div className="bg-white mb-5" style={{ borderRadius: 16, padding: 22, border: '1px solid var(--line)' }}>
                <div className="font-bold tracking-widest mb-3" style={{ fontSize: 11, color: 'var(--muted)' }}>COURSE STATS</div>
                <ul className="list-none p-0 m-0 flex flex-col gap-3">
                  {[
                    ['Total students',     '24,103'],
                    ['Completion rate',    '94%'],
                    ['Avg. rating',        '4.92 / 5.0'],
                    ['Certificates issued', '16,820'],
                    ['Updated',             'Mar 2026'],
                  ].map(([k, v]) => (
                    <li key={k} className="flex justify-between" style={{ fontSize: 13 }}>
                      <span style={{ color: 'var(--muted)' }}>{k}</span>
                      <span className="font-bold">{v}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="bg-white" style={{ borderRadius: 16, padding: 22, border: '1px solid var(--line)' }}>
                <div className="flex items-center gap-2.5 mb-3">
                  <ImageSlot id="review-1" style={{ width: 36, height: 36 }} shape="circle" placeholder="" />
                  <div>
                    <div className="font-bold" style={{ fontSize: 13 }}>Maria K.</div>
                    <div style={{ fontSize: 11, color: 'var(--yellow-2)' }}>★★★★★ · Finland</div>
                  </div>
                </div>
                <p className="leading-relaxed" style={{ fontSize: 13, color: 'var(--ink-2)' }}>
                  &ldquo;I learned more about AI in 6 weeks talking to Lincoln than in a year of reading articles. The Finnish translation is excellent.&rdquo;
                </p>
              </div>
            </aside>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

function ModuleAccordion({ n, title, lessons, time, open, list }) {
  const [isOpen, setIsOpen] = useState(!!open);
  return (
    <div className="mb-2.5" style={{ border: '1px solid var(--line)', borderRadius: 14, background: isOpen ? 'var(--bg-cream)' : '#fff' }}>
      <div onClick={() => setIsOpen(!isOpen)} role="button" tabIndex={0}
        className="flex items-center gap-4 cursor-pointer" style={{ padding: '18px 22px' }}>
        <div className="inline-flex items-center justify-center font-serif font-bold"
          style={{
            width: 40, height: 40, borderRadius: 10,
            background: isOpen ? 'var(--yellow)' : 'var(--bg-soft)',
            color: isOpen ? 'var(--navy)' : 'var(--ink-2)',
            fontSize: 16,
          }}>{n}</div>
        <div className="flex-1">
          <div className="font-semibold" style={{ fontSize: 17, color: 'var(--ink)' }}>{title}</div>
          <div className="mt-1" style={{ fontSize: 12, color: 'var(--muted)' }}>{lessons} lessons · {time}</div>
        </div>
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="var(--muted)" strokeWidth="2.4"
          style={{ transform: isOpen ? 'rotate(180deg)' : 'rotate(0)', transition: 'transform .2s' }}>
          <polyline points="6,9 12,15 18,9" />
        </svg>
      </div>
      {isOpen && list && (
        <div className="flex flex-col gap-2" style={{ padding: '0 22px 18px 78px' }}>
          {list.map((l) => (
            <div key={l.name} className="bg-white flex items-center gap-3" style={{ padding: '10px 14px', borderRadius: 8, fontSize: 13, border: '1px solid var(--line)' }}>
              <span className="inline-flex items-center justify-center rounded-full"
                style={{
                  width: 26, height: 26,
                  background: l.quiz ? 'rgba(34,181,114,0.12)' : 'rgba(43,108,217,0.1)',
                  color: l.quiz ? 'var(--green-2)' : 'var(--blue)',
                  fontSize: 11,
                }}>{l.quiz ? '✓' : '▶'}</span>
              <span className="flex-1" style={{ fontWeight: l.quiz ? 700 : 500 }}>{l.name}</span>
              <span style={{ color: 'var(--muted)' }}>{l.time}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
